<script>
import { addSmallTaskToToday } from '@/services/SmallTasksServices';

export default {
  data() {
    return {
      newSmallTask: '',
    };
  },
  computed: {
    uId() { return this.$store.getters['uId']; },
    token() { return this.$store.getters['token']; },
    today() { return this.$store.getters['today']; },
    todayActual() { return this.$store.getters['todayActual']; },
  },
  emits: [ 'addedNewSmallTask' ],
  methods: {
    async addSmallTask() {
      // code code code - do stuff here
      const task = {
        task: this.newSmallTask.trim(),
        stacked: false,
        dateCreated: this.todayActual,
        dateUpdated: this.todayActual,
      };
      const successfullyCreatedSmallTask = await addSmallTaskToToday(this.uId, this.token, this.today, task);
      if (successfullyCreatedSmallTask) {
        this.$emit('addedNewSmallTask');
      }
      this.newSmallTask = ''; // reset the input value
      this.$nextTick(() => { // re-focus on the newSmallTask input
        this.$refs.newSmallTaskDescriptionInput?.focus();
      });
    },
  },
};
</script>

<template>

  <v-textarea v-model="newSmallTask"
              ref="newSmallTaskDescriptionInput"
              class="new-small-task-description-input mt-3"
              variant="outlined"
              rows="1" auto-grow
              label="Add 3-5 small tasks"
  ></v-textarea>

  <div class="d-flex justify-end" style="margin-top: -16px;">
    <v-btn @click.prevent="addSmallTask"
           density="compact"
           class="text-capitalize px-2"
           :class="newSmallTask ? 'bg-green-lighten-3' : ''"
           :disabled="!newSmallTask"
    >Add Small Task</v-btn>
  </div>

</template>
